import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { landAxios } from '@Root/utils/landAxios'
import MyhouseMainHouseResponse from '@Types/entities/MyhouseMainHouseResponse'
import { FETCH_STATUS } from '@Root/contants'
import { makeHouseLabel, MyhouseLabelType } from '@Root/utils/houseLabelUtils'

export const fetchHouseList = createAsyncThunk('/settings/list', async () => {
  return await (await landAxios.get(`/myhouse/v2`)).data
})

export const fetchRemoveHouse = createAsyncThunk('/settings/remove', async (param: { houseNo: number }) => {
  return await (await landAxios.delete(`/myhouse/v2/${param.houseNo}`)).data
})

export const fetchReorderHouse = createAsyncThunk('settings/reorder', async (param: { myHouseNo: number; myHouseOrder: number }[]) => {
  return await (await landAxios.patch('myhouse/reorder', param)).data
})

export type MyhouseMainHouseResponseType = {
  houseList: MyhouseMainHouseResponse[]
  houseLabel: MyhouseLabelType[]
  fetchStatus: string
  fetchStatusReorder: string
  statusReorder: string
  removeHouseNo: number
  fetchStatusRemove: string
}

const initialState: MyhouseMainHouseResponseType = {
  houseList: [],
  houseLabel: [],
  fetchStatus: FETCH_STATUS.INITIAL,
  fetchStatusReorder: FETCH_STATUS.INITIAL,
  statusReorder: FETCH_STATUS.INITIAL,
  removeHouseNo: 0,
  fetchStatusRemove: FETCH_STATUS.INITIAL,
}

export const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    updateRemoveHouseNo: (state: MyhouseMainHouseResponseType, action: PayloadAction<number>) => {
      state.removeHouseNo = action.payload
    },
    updateReorderHouse: (state: MyhouseMainHouseResponseType, action: PayloadAction<MyhouseLabelType[]>) => {
      state.houseLabel = action.payload
      state.statusReorder = FETCH_STATUS.SUCCESS
    },
    updateFetchStatusRemove: (state: MyhouseMainHouseResponseType, action: PayloadAction<FETCH_STATUS>) => {
      state.fetchStatusRemove = action.payload
    },
  },
  extraReducers: {
    [fetchHouseList.fulfilled.type]: (state: MyhouseMainHouseResponseType, action: PayloadAction<MyhouseMainHouseResponse[]>) => {
      state.houseList = action.payload
      state.houseLabel = makeHouseLabel(state.houseList)
      state.fetchStatus = FETCH_STATUS.SUCCESS
    },
    [fetchHouseList.pending.type]: (state: MyhouseMainHouseResponseType) => {
      state.fetchStatus = FETCH_STATUS.PENDING
    },
    [fetchHouseList.rejected.type]: (state: MyhouseMainHouseResponseType) => {
      state.fetchStatus = FETCH_STATUS.FAILURE
    },
    [fetchReorderHouse.fulfilled.type]: (state: MyhouseMainHouseResponseType) => {
      state.fetchStatusReorder = FETCH_STATUS.SUCCESS
    },
    [fetchRemoveHouse.fulfilled.type]: (state: MyhouseMainHouseResponseType) => {
      state.fetchStatusRemove = FETCH_STATUS.SUCCESS
      const houseList = [...state.houseList]
      houseList.splice(
        houseList.findIndex((item) => item.houseNo === state.removeHouseNo),
        1,
      )
      state.houseList = houseList

      const houseLabel = [...state.houseLabel]
      houseLabel.splice(
        houseLabel.findIndex((item) => item.houseNo === state.removeHouseNo),
        1,
      )
      state.houseLabel = houseLabel
      state.removeHouseNo = 0
    },
  },
})

export const { updateRemoveHouseNo, updateReorderHouse, updateFetchStatusRemove } = settingSlice.actions
export default settingSlice.reducer
